import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
interface QuizOption {
  label: string;
  text: string;
  isCorrect: boolean;
}
interface QuizQuestionProps {
  question: string;
  options: QuizOption[];
  explanation: string;
}
export function QuizQuestion({
  question,
  options,
  explanation
}: QuizQuestionProps) {
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const handleSelect = (label: string) => {
    setSelectedOption(label);
  };
  const selected = options.find(opt => opt.label === selectedOption);
  return <div className="space-y-4" data-id="element-86">
      <h3 className="text-lg font-semibold text-gray-900" data-id="element-87">{question}</h3>

      <div className="space-y-3" data-id="element-88">
        {options.map(option => {
        const isSelected = selectedOption === option.label;
        const showFeedback = isSelected && selectedOption !== null;
        return <button key={option.label} onClick={() => handleSelect(option.label)} disabled={selectedOption !== null} className={`w-full text-left px-4 py-3 rounded-lg border-2 transition-all ${showFeedback ? option.isCorrect ? 'border-green-500 bg-green-50' : 'border-red-500 bg-red-50' : 'border-gray-300 bg-white hover:border-teal-400'} ${selectedOption !== null ? 'cursor-default' : 'cursor-pointer'}`} data-id="element-89">
              <div className="flex items-center justify-between" data-id="element-90">
                <span className="font-medium text-gray-900" data-id="element-91">
                  {option.label}) {option.text}
                </span>
                {showFeedback && <motion.div initial={{
              scale: 0
            }} animate={{
              scale: 1
            }} transition={{
              type: 'spring',
              stiffness: 500,
              damping: 25
            }} data-id="element-92">
                    {option.isCorrect ? <CheckIcon className="w-6 h-6 text-green-600" aria-label="Correct" data-id="element-93" /> : <XIcon className="w-6 h-6 text-red-600" aria-label="Incorrect" data-id="element-94" />}
                  </motion.div>}
              </div>
            </button>;
      })}
      </div>

      <AnimatePresence data-id="element-95">
        {selectedOption && <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className={`p-4 rounded-lg ${selected?.isCorrect ? 'bg-green-50 border border-green-200' : 'bg-blue-50 border border-blue-200'}`} data-id="element-96">
            <p className="text-sm text-gray-700" data-id="element-97">{explanation}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}